// Put zip or postal code into the appropriate format XXXXX-XXXX
// Inserts the zip or postal code hyphen if there are at least five digits entered
const formatZipPostal = value => (value ? value.replace(/(.....)(.)/, '$1-$2') : '');

export default formatZipPostal;
